import { LeagueMembershipModel } from "@/models/LeagueMembershipModels";
import { BaseRepo } from "./base/BaseRepo";
import { createLeagueMembershipMigrationManager } from "@/utils/migrations";


// src/repos/LeaguesRepo.ts
/**
 * Repository for models in the leagues collection
 */
export class LeagueMembershipsRepo extends BaseRepo<LeagueMembershipModel> {
    protected collectionName = 'leagueMemberships';

    constructor() {
        super();
        this.setupMigrations(createLeagueMembershipMigrationManager());
    }

}